// extracted by mini-css-extract-plugin
export default {"profile-icon":"profile-icon_profile-icon__KoM9g","profile-menu":"profile-icon_profile-menu__8zdLK"};